import { faLocationDot } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar } from '@mui/material';
import { convertIconSize } from '@resurs-internal/mui/components/Icon/Icon';

export type CountryIconResolverProps = {
  countryCode?: string;
};

export const CountryIconResolver = ({
  countryCode,
}: CountryIconResolverProps) => {
  if (countryCode)
    return (
      <Avatar
        alt={`flag-${countryCode}`}
        data-cy="CountryIconResolver"
        src={`https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/${countryCode.toLocaleLowerCase()}.svg`}
        sx={{
          alignItems: 'center',
          backgroundColor: 'transparent',
          display: 'flex',
          height: convertIconSize('lg'),
          margin: 'auto',
          width: convertIconSize('lg'),
        }}
      />
    );

  return (
    <FontAwesomeIcon
      data-cy="CountryIconResolver"
      icon={faLocationDot}
      size="2xl"
    />
  );
};
